// -------------------------------------------- IMPORT FILES START --------------------------------------------------------------
// ## Import Files
import $api from "../Api";
import ResponseChecker from "../Middlewares/ResponseChecker";
import { defaultMessages } from "../enums/responseMessages.js";

import Endpoints from "../Endpoints";

// -------------------------------------------- IMPORT FILES ENDED --------------------------------------------------------------

// ## Export ExportSaleToMikro
/**
 *
 * @param { saleId: string} form
 *
 * @returns
 */
export const ExportSaleToMikro = async (form) => {
  const response = await $api.post(
    Endpoints.Export.Mikro.ExportSaleToMikro(),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);

  return checker;
};
// ## Export ExportSaleToMikro
/**
 *
 * @param { "integrationId": "string", "customerId": "string" } form
 *
 * @returns
 */
export const ExportCustomerToMikro = async (form) => {
  const response = await $api.post(
    Endpoints.Export.Mikro.ExportCustomerToMikro(),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);

  return checker;
};

export default {
  ExportSaleToMikro,
  ExportCustomerToMikro,
};
